module.exports = __webpack_public_path__ + "static/media/nazka-team-2_thumb.309d5a12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/nazka-team-2_thumb.jpg
// module id = 287
// module chunks = 0